import { CombinedError } from 'urql'

type GqlErrorMessage = 'job-not-found' | 'no-user-found-with-email' | (string & {})

export function gqlErrorMessage(
    err: CombinedError | undefined,
): GqlErrorMessage | undefined {
    if (err) {
        return err.graphQLErrors[0].message
    }
}

const errorMessageToStatusCode = (message?: GqlErrorMessage) => {
    if (!message) {
        return undefined
    }
    if (['job-not-found'].includes(message)) {
        return 404
    }
    return 500
}

export const gqlErrorToStatusCode = (err: CombinedError | undefined) => {
    return errorMessageToStatusCode(gqlErrorMessage(err))
}
